var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.regexp.replace", "core-js/modules/es6.array.find", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "prop-types", "react", "../../css", "../../propTypes", "../../UI/Icon/Play", "../../UI/Interchange/Interchange", "../../UI/RenderLink/RenderLink", "./ConcertGuideProgram", "./GuideProgram.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.regexp.replace"), require("core-js/modules/es6.array.find"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("prop-types"), require("react"), require("../../css"), require("../../propTypes"), require("../../UI/Icon/Play"), require("../../UI/Interchange/Interchange"), require("../../UI/RenderLink/RenderLink"), require("./ConcertGuideProgram"), require("./GuideProgram.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Regexp, global.es6Array, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.propTypes, global.react, global.css, global.propTypes, global.Play, global.Interchange, global.RenderLink, global.ConcertGuideProgram, global.GuideProgram);
    global.GuideProgram = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _es6Regexp2, _es6Array, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _propTypes, _react, _css, _propTypes2, _Play, _Interchange, _RenderLink, _ConcertGuideProgram, _GuideProgram) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.lowerThanMediumMediaQuery = _exports.higherThanMediumMediaQuery = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Play = _interopRequireDefault(_Play);
  _Interchange = _interopRequireDefault(_Interchange);
  _RenderLink = _interopRequireDefault(_RenderLink);
  _ConcertGuideProgram = _interopRequireDefault(_ConcertGuideProgram);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var higherThanMediumMediaQuery = (0, _css.showFor)('medium');
  _exports.higherThanMediumMediaQuery = higherThanMediumMediaQuery;
  var lowerThanMediumMediaQuery = (0, _css.hideFor)('medium');
  _exports.lowerThanMediumMediaQuery = lowerThanMediumMediaQuery;

  var GuideProgram = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(GuideProgram, _PureComponent);

    var _super = _createSuper(GuideProgram);

    function GuideProgram() {
      (0, _classCallCheck2.default)(this, GuideProgram);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(GuideProgram, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            beginsAt = _this$props.beginsAt,
            collection = _this$props.collection,
            description = _this$props.description,
            hidden = _this$props.hidden,
            images = _this$props.images,
            labels = _this$props.labels,
            mouseFocus = _this$props.mouseFocus,
            renderLink = _this$props.renderLink,
            showDate = _this$props.showDate,
            showHour = _this$props.showHour,
            stickers = _this$props.stickers,
            subtitle = _this$props.subtitle,
            tabIndex = _this$props.tabIndex,
            title = _this$props.title,
            url = _this$props.url,
            domain = _this$props.domain;
        var fullVideo = stickers && stickers.find(function (el) {
          return el.code === 'FULL_VIDEO';
        }) || false;
        var isLive = stickers && stickers.find(function (el) {
          return el.code === 'LIVE';
        }) || false;
        var StyledProgramLink = (0, _GuideProgram.stylingProgramLink)(_RenderLink.default);

        if (domain === 'concert') {
          return /*#__PURE__*/_react.default.createElement(_ConcertGuideProgram.default, this.props);
        }

        return /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgram, null, /*#__PURE__*/_react.default.createElement(StyledProgramLink, {
          "aria-hidden": hidden,
          href: url,
          tabIndex: tabIndex,
          renderLink: renderLink,
          mouseFocus: mouseFocus
        }, /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramFigure, null, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
          images: images,
          title: title,
          breakpointFormat: _propTypes2.default.breakpointFormat,
          hover: _css.hovers.basic,
          ariaOptions: {
            role: 'presentation'
          },
          noFocus: true
        })), /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramWrapper, null, /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramHeader, null, showDate && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramDate, null, /*#__PURE__*/_react.default.createElement("span", {
          className: lowerThanMediumMediaQuery
        }, labels.shortDate), /*#__PURE__*/_react.default.createElement("span", {
          className: higherThanMediumMediaQuery
        }, labels.longDate)), showHour && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramHour, {
          showDate: showDate
        }, labels.hour), fullVideo && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramPlay, null, /*#__PURE__*/_react.default.createElement(_Play.default, {
          title: fullVideo.label
        })), isLive && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramLive, null, labels.live)), /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramTitlesWrapper, {
          withPlaceholder: true
        }, /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramTitle, null, title, subtitle && /*#__PURE__*/_react.default.createElement("span", {
          className: lowerThanMediumMediaQuery
        }, " - ", subtitle)), subtitle && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramSubTitle, {
          className: higherThanMediumMediaQuery
        }, subtitle), beginsAt && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramBegins, null, beginsAt), collection && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramButton, {
          href: collection.url,
          className: higherThanMediumMediaQuery
        }, /*#__PURE__*/_react.default.createElement("span", null, collection.label))))), description && /*#__PURE__*/_react.default.createElement(_GuideProgram.StyledProgramDescription, {
          moveUp: !subtitle
        }, description.replace(/(<br\/>|<br \/>|<br>)/, ' ').replace(/(<([^>]+)>)/gi, '')));
      }
    }]);
    return GuideProgram;
  }(_react.PureComponent);

  GuideProgram.propTypes = {
    beginsAt: _propTypes.default.string,
    concertLabels: _propTypes.default.shape({
      onAir: _propTypes.default.string,
      livestream: _propTypes.default.string
    }),
    labelType: _propTypes.default.oneOf(['LIVESTREAM_WEB', 'LIVESTREAM_TV']),
    collection: _propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired
    }),
    description: _propTypes.default.string,
    domain: _propTypes.default.oneOf(['tv', 'concert']),
    hidden: _propTypes.default.bool,
    images: _propTypes.default.arrayOf(_propTypes2.default.image),
    labels: _propTypes.default.shape({
      hour: _propTypes.default.string.isRequired,
      live: _propTypes.default.string.isRequired,
      shortDate: _propTypes.default.string.isRequired,
      longDate: _propTypes.default.string
    }).isRequired,
    mouseFocus: _propTypes.default.bool,
    renderLink: _propTypes.default.func,
    showDate: _propTypes.default.bool,
    showHour: _propTypes.default.bool,
    stickers: _propTypes.default.arrayOf(_propTypes2.default.stickers),
    subtitle: _propTypes.default.string,
    tabIndex: _propTypes.default.number,
    title: _propTypes.default.string.isRequired,
    url: _propTypes.default.string
  };
  GuideProgram.defaultProps = {
    concertLabels: {
      onAir: '',
      livestream: ''
    },
    description: '',
    hidden: false,
    labels: {
      hour: '',
      live: 'live',
      longDate: '',
      shortDate: ''
    },
    images: [],
    mouseFocus: false,
    showDate: false,
    showHour: true,
    title: '',
    url: '#'
  };
  var _default = GuideProgram;
  _exports.default = _default;
});